export function isDevelopment(): boolean {
  return process.env.NODE_ENV === 'development';
}

export function isProduction(): boolean {
  return process.env.NODE_ENV === 'production';
}

export default {
  sanity: {
    dataset: process.env.VUE_APP_SANITY_DATASET,
    projectId: process.env.VUE_APP_SANITY_PROJECT_ID,
  },
  nodeEnv: process.env.NODE_ENV,
};
